import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Oval } from "react-loader-spinner";
import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import { PutObjectCommand, S3Client } from "@aws-sdk/client-s3";
import "./App.css";
import * as apiCall from "./api/apiCall";
import Overview from "./components/Overview/Overview";
import logo from "./data/logoogc.png";

// Configure AWS SDK

const s3Client = new S3Client({
  region: process.env.REACT_APP_AWS_REGION,
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  },
});

const bucketName = process.env.REACT_APP_S3_BUCKET_NAME;
const region = process.env.REACT_APP_AWS_REGION;

const App = () => {
  const [imageUrl, setImageUrl] = useState(null);
  const [submission, setSubmission] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [clubData, setclubData] = useState(null);
  const [imageToUpload, setImageToUpload] = useState(null);
  //Get URL params for slug
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const slug = searchParams.get("slug");
  const event = searchParams.get("event");
  console.log("slug : ", slug);

  // getPlaces data
  useEffect(() => {
    async function clubData(cs, eventName) {
      let data = await apiCall.getPlaces(cs, eventName);
      console.log("clubData", data);
      setclubData(data);
    }
    clubData(slug, event);
  }, [slug]);

  //send data to s3
  const uploadToS3 = async (imageSrc) => {
    const blob = new Blob([imageSrc], { type: "image/jpeg" });
    const key = `${Date.now()}-${Math.floor(Math.random() * 100000)}`;
    const getUrl = (key, bucketName, region) => {
      let imageUrl = `https://s3.${region}.amazonaws.com/${bucketName}/${key}`;
      console.log("imageUrl ", imageUrl);
      return { imageUrl, key };
    };

    const command = new PutObjectCommand({
      Bucket: bucketName,
      Key: key,
      Body: blob,
      ContentType: "image/jpeg",
      ACL: "public-read",
    });

    try {
      const response = await s3Client.send(command);
      let imageUrl = getUrl(key, bucketName, region);
      console.log("url: ", imageUrl);
      console.log("Image uploaded successfully:", response);
      return imageUrl;
    } catch (error) {
      console.error("Error uploading image to S3:", error);
    }
  };

  const handleInputChange = async (event) => {
    const file = event.target.files[0];
    console.log(file);
    const imageUrl = URL.createObjectURL(file);
    //const imageUrl = await uploadToS3(file);
    setImageUrl(imageUrl);
    setImageToUpload(file);
  };

  const send = async (formData, message) => {
    console.log(formData);

    // Envoie des données utilisateur à l'API (exemple: extraction des données utilisateur)
    await apiCall.userExtract(
      formData.email,
      formData.phone,
      event,
      "STADE",
      "photoshoot",
      formData.lastName,
      formData.firstName,
      formData.optin,
      slug
    );

    // Upload de l'image sur S3
    const result = await uploadToS3(imageToUpload);
    console.log("s3 upload", result);
    const inTemplate = result.imageUrl;
    const dbKey = result.key;

    try {
      // Envoi du message à l'API Gateway pour être publié dans SQS
      const response = await fetch(
        "https://rrfarsgehb.execute-api.eu-west-3.amazonaws.com/dev/photos",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: dbKey,
            cs: slug,
            msg: message,
            picUrl: inTemplate,
            toBroadcast: false,
            alreadyBroadcast: false,
            user: formData,
          }),
        }
      );

      if (response.ok) {
        console.log("Data sent successfully:", await response.json());

        // Vous passez à un autre état ou écran sans attendre la réponse de la Lambda
        // Exemple: changer l'état ou naviguer vers une autre page
        setSubmission(true); // Vous pouvez mettre cette ligne pour afficher un message de succès
        //navigate("/success"); // Redirection immédiate après l'envoi
      } else {
        console.error("Error sending data:", response.statusText);
        setSubmission(false);
      }
    } catch (error) {
      console.error("Error sending data:", error);
      setSubmission(false);
    }
  };

  return (
    <div>
      {clubData && (
        <div
          className="App"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: `${clubData.bgColor}`,
            color: `${clubData.textColor}`,
            //backgroundImage: `url(${clubData[0].backgroundImg})`,
            //backgroundSize: "cover",
            //backgroundRepeat: "no-repeat",
          }}
        >
          {!submission ? (
            <>
              {imageUrl ? (
                <div className="imgZone">
                  <Overview
                    clubData={clubData}
                    imageUrl={imageUrl}
                    setIsLoading={setIsLoading}
                    isLoading={isLoading}
                    send={send}
                    setImageUrl={setImageUrl}
                  />
                  <>
                    {isLoading && (
                      <div className="loaderContainer">
                        <Oval
                          height={80}
                          width={80}
                          color={clubData.btnColor}
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={true}
                          ariaLabel="oval-loading"
                          secondaryColor={clubData.btnColor}
                          strokeWidth={2}
                          strokeWidthSecondary={2}
                        />
                      </div>
                    )}
                  </>
                </div>
              ) : (
                <div className="home">
                  <div className="logo">
                    <img src={clubData.logo} />
                  </div>
                  <div className="explanationText">{clubData.welcomeText}</div>
                  <div className="takepic">
                    <label
                      htmlFor="photo-input"
                      className="photo-button"
                      style={{
                        backgroundColor: `${clubData.btnColor}`,
                      }}
                    >
                      <PhotoCameraOutlinedIcon
                        style={{ color: `${clubData.textColor}` }}
                      />
                      <span style={{ color: `${clubData.textColor}` }}>
                        Prendre une photo
                      </span>
                    </label>
                    <input
                      id="photo-input"
                      accept="image/*"
                      capture="user"
                      onChange={handleInputChange}
                      type="file"
                      tabIndex="0"
                      aria-label="Prends toi en photo"
                      aria-required="true"
                      aria-invalid="false"
                      className="photo-input"
                    />
                  </div>
                </div>
              )}
            </>
          ) : (
            <p
              style={{ display: "flex", height: "100vh", alignItems: "center" }}
            >
              Merci de votre participation !{" "}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default App;
